export const ACTIVITY_SORT_BY_TYPE = {
    TIMESTAMP: 'createdAt',
    LOCATION: 'shop',
    EMPLOYEE: 'staff',
    CLIENT: 'client',
    PRODUCT_TYPE: 'product',
    PRODUCT_NAME: 'productName',
    ACTION: 'action',
};
